module.exports = __webpack_public_path__ + "static/img/star.ffa3f8c5.png";